module.exports = __webpack_public_path__ + "img/nextIcon.a04afb77.png";